import { useDictionary, OrderStates } from "@adamlip/okeoke.client"
import IconComponent from "components/IconComponent"
import { MainContext } from "contexts/MainContext"
import { useContext } from "react"
import useBasket from "hooks/useBasket"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function BasketBadgeIcon({ size, sizes, text, textMax, data }) {
  const { appParams } = useContext(AppParamsContext)
  const { handleClickCart } = useContext(MainContext)
  const { getValue } = useDictionary()
  const { itemCount, orderState } = useBasket()

  return (
    <div
      className={`transition-colors flex flex-col shrink-0 gap-1 h-full cursor-pointer`}
      onClick={() => handleClickCart()}
    >
      <div
        className={`mx-auto ${
          size != null ? sizes?.[size] : "w-[55px] h-[55px]"
        } !bg-[var(--top-bar-nav-bg-color)] ${
          appParams?.styles?.borderRadius?.navBar || "rounded-full"
        } relative`}
      >
        <div
          className={`absolute top-[-5px] right-[-5px] rounded-full w-6 h-6 flex items-center justify-center text-sm bg-[var(--top-bar-cart-badge-bg-color)] text-[var(--top-bar-cart-badge-text-color)] ${
            itemCount > 0 && orderState === OrderStates.BASKET
              ? "basket-badge-visible"
              : "basket-badge-not-visible"
          }`}
        >
          {itemCount}
        </div>
        <IconComponent
          iconCode={data?.iconCode || "basket"}
          className={"[var(--top-bar-icon-color)]"}
        />
      </div>
      {text !== "hidden" && (
        <div
          className={`text-sm text-center truncate ${
            size != null ? textMax?.[size] : "max-w-[55px]"
          }`}
        >
          {getValue("app_v2_topBar_cartText")}
        </div>
      )}
    </div>
  )
}
